export default __webpack_public_path__ + "static/media/outfit_airjordan.577764b8.png";